module.exports = __webpack_public_path__ + "static/media/delaatsolar_24dpi.d8a6eb56.png";